"use strict";

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var cql = require('cql-execution');
var load = require('./load');
var util = require('./util');
var FHIRv102XML = require('./modelInfos/fhir-modelinfo-1.0.2.xml.js');
var FHIRv300XML = require('./modelInfos/fhir-modelinfo-3.0.0.xml.js');
var FHIRv400XML = require('./modelInfos/fhir-modelinfo-4.0.0.xml.js');
var FHIRv401XML = require('./modelInfos/fhir-modelinfo-4.0.1.xml.js');
var FHIRWrapper = /*#__PURE__*/function () {
  function FHIRWrapper(filePathOrXML) {
    _classCallCheck(this, FHIRWrapper);
    this._modelInfo = load(filePathOrXML);
  }
  return _createClass(FHIRWrapper, [{
    key: "wrap",
    value: function wrap(fhirJson) {
      var fhirResourceType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var targetClassName = fhirResourceType || fhirJson.resourceType;
      var targetClass = this._modelInfo.findClass(targetClassName);

      // If the FHIR resource specifies a type and a target type is specified, verify they are compatible
      if (fhirResourceType && fhirJson.resourceType) {
        var currentClass = this._modelInfo.findClass(fhirJson.resourceType);
        if (!this._typeCastIsAllowed(currentClass, targetClass)) throw "Incompatible types: FHIR resourceType is ".concat(fhirJson.resourceType, " which cannot be cast as ").concat(fhirResourceType);
      }
      return new FHIRObject(fhirJson, targetClass, this._modelInfo);
    }
  }, {
    key: "_typeCastIsAllowed",
    value: function _typeCastIsAllowed(currentClass, targetClass) {
      return targetClass == currentClass || currentClass.parentClasses().includes(targetClass) ||
      // upcasting, safe
      targetClass.parentClasses().includes(currentClass) // downcasting, unsafe but allowed
      ;
    }
  }], [{
    key: "FHIRv102",
    value: function FHIRv102() {
      return new FHIRWrapper(FHIRv102XML);
    }
  }, {
    key: "FHIRv300",
    value: function FHIRv300() {
      return new FHIRWrapper(FHIRv300XML);
    }
  }, {
    key: "FHIRv400",
    value: function FHIRv400() {
      return new FHIRWrapper(FHIRv400XML);
    }
  }, {
    key: "FHIRv401",
    value: function FHIRv401() {
      return new FHIRWrapper(FHIRv401XML);
    }
  }]);
}();
var PatientSource = /*#__PURE__*/function () {
  function PatientSource(filePathOrXML) {
    var patientSourceOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, PatientSource);
    this._index = 0;
    this._bundles = [];
    this._patientSourceOptions = patientSourceOptions;
    this._modelInfo = load(filePathOrXML);
  }

  // Convenience factory method for getting a FHIR 1.0.2 (DSTU2) Patient Source
  return _createClass(PatientSource, [{
    key: "version",
    get: function get() {
      return this._modelInfo.version;
    }
  }, {
    key: "loadBundles",
    value: function loadBundles(bundles) {
      this._bundles = this._bundles.concat(bundles);
    }
  }, {
    key: "currentPatient",
    value: function currentPatient() {
      if (this._index < this._bundles.length) {
        return new Patient(this._bundles[this._index], this._modelInfo, this._patientSourceOptions);
      }
    }
  }, {
    key: "nextPatient",
    value: function nextPatient() {
      // Advance the index to go to the next patient, allowing to advance one beyond the length (but no more)
      if (this._index < this._bundles.length) {
        this._index++;
      }
      return this.currentPatient();
    }
  }, {
    key: "reset",
    value: function reset() {
      this._index = 0;
      this._bundles = [];
    }
  }], [{
    key: "FHIRv102",
    value: function FHIRv102(patientSourceOptions) {
      return new PatientSource(FHIRv102XML, patientSourceOptions);
    }

    // Convenience factory method for getting a FHIR 3.0.0 (STU3) Patient Source
  }, {
    key: "FHIRv300",
    value: function FHIRv300(patientSourceOptions) {
      return new PatientSource(FHIRv300XML, patientSourceOptions);
    }

    // Convenience factory method for getting a FHIR 4.0.0 (R4) Patient Source
  }, {
    key: "FHIRv400",
    value: function FHIRv400(patientSourceOptions) {
      return new PatientSource(FHIRv400XML, patientSourceOptions);
    }

    // Convenience factory method for getting a FHIR 4.0.1 (R4) Patient Source
  }, {
    key: "FHIRv401",
    value: function FHIRv401(patientSourceOptions) {
      return new PatientSource(FHIRv401XML, patientSourceOptions);
    }
  }]);
}();
var FHIRObject = /*#__PURE__*/function () {
  function FHIRObject(json, typeInfo, modelInfo) {
    var _this = this;
    _classCallCheck(this, FHIRObject);
    // Define "private" un-enumerable properties to hold internal data
    Object.defineProperties(this, {
      _json: {
        value: json,
        enumerable: false
      },
      _typeInfo: {
        value: typeInfo,
        enumerable: false
      },
      _modelInfo: {
        value: modelInfo,
        enumerable: false
      }
    });
    if (typeInfo == null) {
      console.error("Failed to locate typeInfo for ".concat(json));
      return;
    }
    var elementNames = new Set();
    for (var currentInfo = typeInfo; currentInfo != null;) {
      currentInfo.elements.forEach(function (e) {
        return elementNames.add(e.name);
      });
      if (currentInfo.baseTypeSpecifier != null) {
        currentInfo = modelInfo.findClass(currentInfo.baseTypeSpecifier.fqn);
      } else {
        currentInfo = null;
      }
    }
    var _iterator = _createForOfIteratorHelper(elementNames),
      _step;
    try {
      var _loop = function _loop() {
        var name = _step.value;
        Object.defineProperty(_this, name, {
          get: function get() {
            return this.get(name);
          },
          enumerable: true
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  // Required by cql-execution API
  return _createClass(FHIRObject, [{
    key: "get",
    value: function get(field) {
      if (this._json == null) {
        // preserve distinction between null or undefined
        return this._json;
      }
      var parts = field.split('.');
      var root = parts[0];
      var suffix = parts.length > 1 ? parts.splice(1).join('.') : undefined;
      var element = this._typeInfo.findElement(root, true); // true: support explicit choices
      if (typeof element === 'undefined') {
        console.error("Failed to locate element for ".concat(this._typeInfo.name, ".").concat(root));
        return;
      }
      var choicePropertyName = function choicePropertyName(element, choice) {
        var choiceName = util.normalizeChoiceName(choice.name);
        return "".concat(element.name).concat(choiceName[0].toUpperCase()).concat(choiceName.slice(1));
      };
      var property, typeSpecifier;
      if (root !== element.name && element.typeSpecifier.isChoice) {
        // This only happens when the root was explicit (e.g., medicationCodeableConcept) but the
        // property is a choice (e.g., medication). In this case we need to find the matchin choice
        // and use it. We don't want other choices, even if they're in the data.
        property = root; // keep the explicit name
        typeSpecifier = element.typeSpecifier.choices.find(function (c) {
          return property === choicePropertyName(element, c);
        });
      } else {
        property = element.name;
        typeSpecifier = element.typeSpecifier;
        if (typeSpecifier.isChoice) {
          // Special handling for choices to find the right value in the FHIR data (e.g., the property
          // might be 'value', but in JSON, it's spelled out as 'valueDateTime').
          var _iterator2 = _createForOfIteratorHelper(typeSpecifier.choices),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var choice = _step2.value;
              if (choice.isNamed) {
                var choiceProperty = choicePropertyName(element, choice);
                if (this._json[choiceProperty] != null || this._json["_".concat(choiceProperty)] != null) {
                  property = choiceProperty;
                  typeSpecifier = choice;
                  break;
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
      if (typeSpecifier.namespace === 'System') {
        // TODO: If there is a suffix, we need to drill into the CQL system type!
        if (suffix != null) {
          console.error("Traversing into CQL system types isn't supported: ".concat(this._typeInfo.name, ".").concat(root, ".").concat(suffix, "."));
          return;
        }
        return toSystemObject(this._json[property], typeSpecifier.name);
      }
      var data = getPropertyFromJSON(this._json, property, typeSpecifier, this._modelInfo);
      if (data == null) {
        // preserve distinction between null or undefined
        return data;
      }
      return toFHIRObject(data, typeSpecifier, this._modelInfo, suffix);
    }

    // Required by cql-execution API (starting w/ 1.2.1)
  }, {
    key: "getId",
    value: function getId() {
      return this._json.id;
    }

    // Required by cql-execution API
  }, {
    key: "getCode",
    value: function getCode(field) {
      var code = this.get(field);
      if (!(code instanceof cql.Code)) {
        code = toCode(code);
      }
      return code;
    }

    // Required by cql-execution API (but not currently used in FHIR data model)
  }, {
    key: "getDate",
    value: function getDate(field) {
      var date = this.get(field);
      if (!(date instanceof cql.DateTime) && date && date.value) {
        date = date.value;
      }
      return date;
    }

    // Required by cql-execution API (but not currently used in FHIR data model)
  }, {
    key: "getInterval",
    value: function getInterval(field) {
      var ivl = this.get(field);
      if (!(ivl instanceof cql.Interval) && ivl && ivl.value) {
        ivl = ivl.value;
      }
      return ivl;
    }

    // Required by cql-execution API (but not currently used in FHIR data model)
  }, {
    key: "getDateOrInterval",
    value: function getDateOrInterval(field) {
      var dateOrIvl = this.get(field);
      if (!(dateOrIvl instanceof cql.DateTime) && !(dateOrIvl instanceof cql.Interval) && dateOrIvl && dateOrIvl.value) {
        dateOrIvl = dateOrIvl.value;
      }
      return dateOrIvl;
    }
  }, {
    key: "_is",
    value: function _is(typeSpecifier) {
      return this._typeHierarchy().some(function (t) {
        return t.type === typeSpecifier.type && t.name == typeSpecifier.name;
      });
    }
  }, {
    key: "_typeHierarchy",
    value: function _typeHierarchy() {
      var typeHierarchy = [];
      if (this.getTypeInfo() != null) {
        typeHierarchy = [this.getTypeInfo()].concat(_toConsumableArray(this.getTypeInfo().parentClasses())).map(function (c) {
          // Account for when the namespace comes in as the model name rather than the model url
          var namespace = c.namespace;
          if (namespace === c.modelInfo.name) {
            namespace = c.modelInfo.url;
          } else if (namespace === 'System') {
            namespace = 'urn:hl7-org:elm-types:r1';
          }
          // Account for when the name is prefixed by the model name and a dot
          var name = c.name;
          if (name.startsWith("".concat(c.modelInfo.name, "."))) {
            name = name.slice(c.modelInfo.name.length + 1);
          }
          name = "{".concat(namespace, "}").concat(name);
          // At this point, all the FHIR models are considered named types
          return {
            name: name,
            type: 'NamedTypeSpecifier'
          };
        });
      }
      // TODO: This currently doesn't include System types in the hierarchy.  We should fix this in the parentClasses
      // function, but until then, we know that everything eventually inherits from System.Any, so force that here:
      typeHierarchy.push({
        name: '{urn:hl7-org:elm-types:r1}Any',
        type: 'NamedTypeSpecifier'
      });
      return typeHierarchy;
    }
  }, {
    key: "getTypeInfo",
    value: function getTypeInfo() {
      return this._typeInfo;
    }
  }]);
}();
var Patient = /*#__PURE__*/function (_FHIRObject) {
  function Patient(bundle, modelInfo) {
    var _this2;
    var patientSourceOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Patient);
    var patientClass = modelInfo.patientClassIdentifier ? modelInfo.patientClassIdentifier : modelInfo.patientClassName;
    var resourceType = modelInfo.patientClassName.replace(/^FHIR\./, '');
    var ptEntry = bundle.entry.find(function (e) {
      return e.resource && e.resource.resourceType == resourceType;
    });
    var ptClass = modelInfo.findClass(patientClass);
    _this2 = _callSuper(this, Patient, [ptEntry.resource, ptClass, modelInfo]);
    _this2._patientSourceOptions = patientSourceOptions;

    // Define a "private" un-enumerable property to hold the bundle
    Object.defineProperty(_this2, '_bundle', {
      value: bundle,
      enumerable: false
    });
    return _this2;
  }
  _inherits(Patient, _FHIRObject);
  return _createClass(Patient, [{
    key: "findRecord",
    value: function findRecord(profile, retrieveDetails) {
      var records = this.findRecords(profile, retrieveDetails);
      if (records.length > 0) {
        return records[0];
      }
    }
  }, {
    key: "findRecords",
    value: function findRecords(profile, retrieveDetails) {
      var _this3 = this;
      var requireProfileTagging = this._patientSourceOptions.requireProfileTagging;

      // retrieveDetails was introduced in cql-execution v2.4.1. If it is missing from the function call
      // profile checking will not work,
      if (requireProfileTagging === true && retrieveDetails == null) {
        throw new Error('meta.profile checking is only supported using cql-execution >=2.4.1. Please upgrade or set the "requireProfileTagging" option to false when constructing a PatientSource.');
      }

      // Preferring the datatype on retrieveDetails allows the engine to properly identify resources where
      // the ELM uses a profile from a specific IG (e.g. US Core)
      var classInfo = this._modelInfo.findClass(retrieveDetails ? retrieveDetails.datatype : profile);
      if (classInfo == null) {
        console.error("Failed to find type info for ".concat(profile));
        return [];
      }
      var resourceType = classInfo.name.replace(/^FHIR\./, '');
      var records = this._bundle.entry.filter(function (e) {
        if (e.resource && e.resource.resourceType == resourceType) {
          if (requireProfileTagging === true && profile !== "http://hl7.org/fhir/StructureDefinition/".concat(resourceType)) {
            return e.resource.meta && e.resource.meta.profile && e.resource.meta.profile.includes(profile);
          }
          return true;
        }
        return false;
      }).map(function (e) {
        return new FHIRObject(e.resource, classInfo, _this3._modelInfo);
      });

      // PatientSources have the assumption that bundles loaded in always have a Patient resources.
      // When "requireProfileTagging" is true, we could encounter a case where the Patient resource is contained in the Bundle
      // but does not have meta.profile set to match the Retrieve of the Patient.
      // In this case, we should throw an error, as we want to ensure that the Patient can properly be retrieved before executing the rest of the ELM Retrieves
      if (requireProfileTagging === true && resourceType === 'Patient' && records.length === 0) {
        throw new Error("Patient record with meta.profile matching ".concat(profile, " was not found. Please ensure that meta.profile is properly set on the Patient resource, or set the \"requireProfileTagging\" option to false when constructing a PatientSource."));
      }
      return records;
    }
  }]);
}(FHIRObject);
/**
 * Extracts a property from the JSON, with special support for handling FHIR primitives that
 * may be spread out over two properties (`${property}` and `_${property}`).
 * @see http://hl7.org/fhir/STU3/json.html#primitive
 * @param {Object} json - the JSON representation from which to extract the property
 * @param {string} property - the property name to extract
 * @param {Object} typeSpecifier - the element information for the property being retrieved
 * @param {Object} modelInfo - the ModelInfo from which the element came
 * @returns {Object}
 */
function getPropertyFromJSON(json, property, typeSpecifier, modelInfo) {
  var value = json[property];
  var extra = json["_".concat(property)];
  if (value == null && extra == null) {
    return json[property];
  }

  // Special handling for FHIR ids and extensions on primitives.
  if (isFHIRPrimitiveOrListOfFHIRPrimitives(typeSpecifier, modelInfo)) {
    // Normalize (or copy) to arrays to better share code between lists and non-lists
    var valueArr = typeSpecifier.isList && Array.isArray(value) ? _toConsumableArray(value) : [value];
    var extraArr = typeSpecifier.isList && Array.isArray(extra) ? _toConsumableArray(extra) : [extra];
    // Make sure arrays are of same length for easier processing
    while (valueArr.length > extraArr.length) {
      extraArr.push(undefined);
    }
    while (extraArr.length > valueArr.length) {
      valueArr.push(undefined);
    }
    var data = [];
    for (var i = 0; i < valueArr.length; i++) {
      var item = {};
      if (typeof valueArr[i] !== 'undefined') {
        item.value = valueArr[i];
      }
      if (extraArr[i] != null) {
        Object.assign(item, extraArr[i]);
      }
      if (valueArr[i] == null && extraArr[i] == null) {
        // preserve undefined/null nature of value if neither value nor extra were found
        item = valueArr[i];
      }
      data.push(item);
    }
    return typeSpecifier.isList ? data : data[0];
  }
  return json[property];
}
function isFHIRPrimitiveOrListOfFHIRPrimitives(typeSpecifier, modelInfo) {
  if (typeSpecifier.isNamed) {
    // If its namespace is FHIR and its name starts w/ a lowercase letter, it's a FHIR primitive
    if (typeSpecifier.namespace === 'FHIR' && typeSpecifier.name[0].toLowerCase() === typeSpecifier.name[0]) {
      return true;
    }
    // The FHIR modelinfo represents code elements as a unique class type with a single string 'value'.
    // e.g., Goal's 'status' element has type 'GoalStatus', which just has a string value element.
    var typeInfo = modelInfo.findClass(typeSpecifier.fqn);
    if (typeInfo && typeInfo.baseTypeSpecifier && typeInfo.baseTypeSpecifier.fqn === 'FHIR.Element' && typeInfo.elements.length === 1) {
      var property = typeInfo.findElement('value');
      return property && property.typeSpecifier.fqn === 'System.String';
    }
    return false;
  } else if (typeSpecifier.isList) {
    return isFHIRPrimitiveOrListOfFHIRPrimitives(typeSpecifier.elementType, modelInfo);
  }
  return false;
}

/**
 * Converts JSON data to the proper CQL System Type as necessary.
 * @param {Object} data - the data to convert to the proper CQL System type
 * @param {string} name - the name of the CQL System Type (e.g., 'Boolean')
 * @returns {Object}
 */
function toSystemObject(data, name) {
  if (data == null) {
    // preserve distinction between null or undefined
    return data;
  }
  switch (name) {
    case 'Boolean':
    case 'Decimal':
    case 'Integer':
    case 'String':
      return data;
    case 'Code':
    case 'Concept':
    case 'Quantity':
      // Currently, these aren't used as leaf nodes in the FHIR model infos!
      return;
    case 'DateTime':
      // CQL DateTime doesn't support 'Z' right now, so account for that.
      return cql.DateTime.parse(data.replace('Z', '+00:00'));
    case 'Date':
      // cql-execution v1.3.2 currently doesn't export the new Date class, so we need to use this workaround
      return cql.DateTime.parse(data) != null ? cql.DateTime.parse(data).getDate() : undefined;
    case 'Time':
      {
        // CQL DateTime doesn't support 'Z' right now, so account for that. In addition Time should not
        // have an offset, so clear the offset as well.
        // NOTE: Current CQL execution treats time as a DateTime w/ date fixed to 0000-01-01.
        var time = cql.DateTime.parse("0000-01-01T".concat(data.replace('Z', '+00:00')));
        time.timezoneOffset = null;
        return time;
      }
  }
}

/**
 * Converts data to a FHIRObject class instance
 * @param {Object} data - the JSON data to populate the FHIR object with
 * @param {Object} typeSpecifier - the TypeSpecifier describing the data
 * @param {ModelInfo} modelInfo - the overall ModelInfo from which this class comes
 * @param {string} suffix - the trailing part of the path to get (e.g., x.y.z)
 * @returns {FHIRObject}
 */
function toFHIRObject(data, typeSpecifier, modelInfo, suffix) {
  if (data == null) {
    // preserve distinction between null or undefined
    return data;
  }
  if (typeSpecifier.isNamed) {
    var rootClassInfo = modelInfo.findClass(typeSpecifier.fqn);
    var rootObject = new FHIRObject(data, rootClassInfo, modelInfo);
    if (suffix != null) {
      return rootObject.get(suffix);
    }
    return rootObject;
  } else if (typeSpecifier.isList) {
    if (suffix != null) {
      console.error('List type found in the middle of a path.');
      return;
    }
    return data.map(function (item) {
      return toFHIRObject(item, typeSpecifier.elementType, modelInfo);
    });
  } else if (typeSpecifier.isInterval) {
    return new cql.Interval(toFHIRObject(data.low, typeSpecifier.pointType, modelInfo), toFHIRObject(data.high, typeSpecifier.pointType, modelInfo), data.lowClosed, data.highClosed);
  }
  return;
}

/**
 * Converts a FHIRObject instance representing a FHIR.CodeableConcept, FHIR.Coding, or FHIR.code
 * to a CQL Code.
 * @param {FHIRObject} f - the FHIRObject instance to convert to a CQL Code
 * @returns {cql.Code}
 */
function toCode(f) {
  if (f == null) {
    // preserve distinction between null or undefined
    return f;
  }
  if (Array.isArray(f)) {
    return f.map(function (c) {
      return toCode(c);
    });
  }
  var typeName = f.getTypeInfo().name.replace(/^FHIR\./, '');
  if (typeName === 'CodeableConcept') {
    if (f.coding == null) {
      // preserve distinction between null or undefined
      return f.coding;
    } else {
      var codings = f.coding.map(function (c) {
        return toCode(c);
      });
      return codings.length === 1 ? codings[0] : codings;
    }
  } else if (typeName === 'Coding') {
    return new cql.Code(f.code ? f.code.value : f.code, f.system ? f.system.value : f.system, f.version ? f.version.value : f.version, f.display ? f.display.value : f.display);
  } else if (typeName === 'code') {
    return f.value;
  }
}
module.exports = {
  PatientSource: PatientSource,
  FHIRWrapper: FHIRWrapper
};